<style lang="scss" scoped>
  pre {
    padding: 0px;
    height: 500px;
    background: hsl(0, 0, 90);
    .code {
      height: 500px;
      background: hsl(0, 0, 90);
    }
  }
</style>


<template>
  <div>
    <pre v-highlightjs="parsed"><code class="json"></code></pre>
  </div>
</template>

<script>
export default {
  name: 'stream',
  props: ['events'],
  computed: {
    parsed() {
      if (Array.isArray(this.events) && this.events.length === 0) return '';
      return JSON.stringify(this.events, null, 2);
    }
  }
};
</script>
